module.exports = __webpack_public_path__ + "static/media/cap1_01a-desk.d0fd5a94.jpg";